import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/merchants`;
const countryResource = `/api/v1/countries`;
const cityResource = `/api/v1/cities`;
const stateResource = `/api/v1/states`;
const forbidenNamesResource = `/api/v1/forbiddennames`;
const merchantDocumentTypesResource = `/api/v1/merchantdocumenttypes`;
const socialMediaResource = `/api/v1/socialmedia`;
const mercchantEventResource = `/api/v1/merchantevents`;
export default {
  checkIsValiNationalId(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/is-valid-national-id`, {
      baseURL,
      headers,
      params,
    });
  },
  getConfirmedMerchant(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/confirmed`, {
      baseURL,
      headers,
      params,
    });
  },
  getAllMerchantsByCurrentUser(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/by-current-user`, {
      baseURL,
      headers,
      params,
    });
  },
  getCompanytypegroups(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`/api/v1/companytypegroups`, {
      baseURL,
      headers,
      params,
    });
  },
  getCompanytypegroupItems(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`/api/v1/companytypegroupitems`, {
      baseURL,
      headers,
      params,
    });
  },
  getProvince(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${stateResource}`, {
      baseURL,
      headers,
      params,
    });
  },
  getFilterCity(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${cityResource}/filter`, {
      baseURL,
      headers,
      params,
    });
  },
  getCityById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${cityResource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  getCityByIdList(baseURL = {}, headers = {}, params = {}, paramsSerializer) {
    return BaseRepository.get(`${cityResource}/byidlist`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  getStatesByIdList(baseURL = {}, headers = {}, params = {}, paramsSerializer) {
    return BaseRepository.get(`${stateResource}/byidlist`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  getCitiesByState(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${cityResource}/filter/bystate`, {
      baseURL,
      headers,
      params,
    });
  },
  getCitiesOfMultipleStates(
    baseURL = {},
    params = {},
    headers = {},
    paramsSerializer
  ) {
    return BaseRepository.get(`${cityResource}/filter/by-state-id-list`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  getCitiesOfMultipleStatesTree(
    baseURL = {},
    params = {},
    headers = {},
    paramsSerializer
  ) {
    return BaseRepository.get(`${cityResource}/group/by-state-id-list`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  getFilterCountry(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${countryResource}/filter`, {
      baseURL,
      headers,
      params,
    });
  },
  getFilterState(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${stateResource}/filter`, {
      baseURL,
      headers,
      params,
    });
  },
  forbidenNamesValidate(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}/is-valid-name`, {
      baseURL,
      headers,
      params,
    });
  },
  getDocumentsByMerchant(id, baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}/${id}/documents`, {
      baseURL,
      headers,
      params,
    });
  },
  editDocumentsByMerchant(id, body, baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.put(`${resource}/${id}/documents`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantDocumentTypes(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${merchantDocumentTypesResource}`, {
      baseURL,
      headers,
      params,
    });
  },
  getSocialMediaList(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${socialMediaResource}`, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantSocialMediaList(
    merchantId,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.get(`${resource}/${merchantId}/social-media`, {
      baseURL,
      headers,
      params,
    });
  },
  addMerchantSocialMedia(
    merchantId,
    body,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.post(`${resource}/${merchantId}/social-media`, body, {
      baseURL,
      headers,
      params,
    });
  },
  editMerchantSocialMedia(
    merchantId,
    body,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.put(`${resource}/${merchantId}/social-media`, body, {
      baseURL,
      params,
      headers,
    });
  },
  removeMerchantSocialMedia(
    merchantId,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.delete(`${resource}/${merchantId}/social-media`, {
      baseURL,
      params,
      headers,
    });
  },
  merchantRequestConfirmation(
    merchantId,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.post(
      `${resource}/${merchantId}/requestconfirmation`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  addMerchantDocument(
    merchantId,
    body,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.post(`${resource}/${merchantId}/documents`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantByUser(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/byuser`, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantImages(merchantId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${merchantId}/images`, {
      baseURL,
      headers,
      params,
    });
  },
  addMerchantImages(merchantId, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/${merchantId}/images`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantInformationById(
    merchantId,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.get(`${resource}/${merchantId}`, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantEvents(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${mercchantEventResource}/merchant-events`, {
      baseURL,
      headers,
      params,
    });
  },
  addUserToMerchantPermittedUser(
    id,
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.post(`${resource}/${id}/adduser`, body, {
      baseURL,
      headers,
      params,
    });
  },
  removeUserToMerchantPermittedUser(
    id,
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.post(`${resource}/${id}/removeuser`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getUserToMerchantPermittedUser(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/getusers`, {
      baseURL,
      headers,
      params,
    });
  },
  postCreatorReplacment(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/creator-replacement`, body, {
      baseURL,
      headers,
      params,
    });
  },
   getMerchantsByname( baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/byname`, {
      baseURL,
      headers,
      params,
    });
  },
    ///api/v1/vendorpermissions/{id}/get
   ////api/v1/vendors/{merchantid}
  getVendorPermission(permissionId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`api/v1/vendorpermissions/${permissionId}/get`, {
      baseURL,
      headers,
      params,
    });
  },
  createVendor(merchantId, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`api/v1/vendors/${merchantId}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  ///api/v1/vendorgroups/{merchantid}/add-group
   createVendorGroup(merchantId, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`api/v1/vendorgroups/${merchantId}/add-group`, body, {
      baseURL,
      headers,
      params,
    });
  },
        ///api/v1/vendorgroups/{id}/edit/{merchantid} put
    editVendorGroup(venGroupId,merchantId, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`api/v1/vendorgroups/${venGroupId}/edit/${merchantId}`, body, {
      baseURL,
      headers,
      params,
    });
  },
 
   ///api/v1/vendorgroups/{id}/getlist-by-merchant
     getVendorGroups(merchantId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`api/v1/vendorgroups/${merchantId}/getlist-by-merchant`, {
      baseURL,
      headers,
      params,
    
    });
  },
    deleteVendorGroupById(
    vGId,merchantid,
    baseURL = {},
    params = {},
    headers = {}
  ) {
    return BaseRepository.delete(`api/v1/vendorgroups/${vGId}/delete/${merchantid}`, {
      baseURL,
      params,
      headers,
    });
  },
  ///api/v1/vendorgroups/{id}/delete/{merchantid}
  ///api/v1/vendorgroups/{id}/getlist-by-merchant
 
     getVendors(merchantId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`api/v1/vendors/${merchantId}/list-by-merchant`, {
      baseURL,
      headers,
      params,
    
    });
  },
     ///api/v1/vendors/{id}
        getVendorById(vendorId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`api/v1/vendors/${vendorId}`, {
      baseURL,
      headers,
      params,
    
    });
  },
  editVendor(vendorId,merchantId, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`api/v1/vendors/${vendorId}/${merchantId}`,body, {
      baseURL,
      headers,
      params,
    
    });
  },
    deleteVendor(vendorId,merchantId,  baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`api/v1/vendors/${vendorId}/${merchantId}`, {
      baseURL,
      headers,
      params,
    
    });
  },
  //For Social Media start
    ///api/v1/merchants/{merchantId}/social-media
    createMerchantSmedia(merchantId, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`api/v1/merchants/${merchantId}/social-media`, body, {
      baseURL,
      headers,
      params,
    });
  },
    ///api/v1/merchants/{merchantId}/social-media
  editMerchantSmedia(merchantId, merchantSocialMediaId , body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`api/v1/merchants/${merchantId}/social-media`,body, {
      baseURL,
      headers,
      params,
    
    });
  },
  ///api/v1/merchants/{merchantId}/social-media
      getMerchantSmedias(merchantId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`api/v1/merchants/${merchantId}/social-media`, {
      baseURL,
      headers,
      params,
    
    });
  },
      ///api/v1/merchants/{merchantId}/social-media
    deleteMerchantSmedia(smediaId,merchantId,  baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`api/v1/merchants/${merchantId}/social-media`, {
      baseURL,
      headers,
      params,
    
    });
  },
  ///api/v1/merchants/{merchantId}/social-media/by-id
  getMerchantSmediaById(merchantId, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`api/v1/merchants/${merchantId}/social-media/by-id`, {
      baseURL,
      headers,
      params,
    
    });
  },
    /// /api/v1/socialmedia
      getGeneralSmediaList( baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`/api/v1/socialmedia`, {
      baseURL,
      headers,
      params,
    });
  },
};
